import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UPDATE_POST_REQUEST, GET_POST_REQUEST } from '../constant';
import PostForm from '../PostForm';
import { useHistory } from 'react-router';
import Layout from '../../Layout';
import { Spin } from 'antd';

const EditPost = ({ isLoadingPost }) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const history = useHistory();

  const handleSubmit = ({ postId, form }) => {
    dispatch({
      type: UPDATE_POST_REQUEST,
      payload: {
        postId,
        form,
        callback: success => {
          if (success) {
            history.push('/posts');
          }
        },
      },
    });
  };

  useEffect(() => {
    dispatch({
      type: GET_POST_REQUEST,
      payload: {
        id,
      },
    });
  }, [dispatch, id]);

  return (
    <Layout title="Edit Post">
      {isLoadingPost ? (
        <div style={{ textAlign: 'center' }}>
          <Spin />
        </div>
      ) : (
        <PostForm onSubmit={handleSubmit} isEdit={true} />
      )}
    </Layout>
  );
};

export default connect(state => ({ isLoadingPost: state.post.isLoadingPost }))(EditPost);
